module.exports = __webpack_public_path__ + "img/Postmodernisme_Litteraturen41.9f57789f.jpg";